import { render, staticRenderFns } from "./FullScreenView.vue?vue&type=template&id=a782baf4"
import script from "./FullScreenView.vue?vue&type=script&lang=js"
export * from "./FullScreenView.vue?vue&type=script&lang=js"
import style0 from "./FullScreenView.vue?vue&type=style&index=0&id=a782baf4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports